module.exports = __webpack_public_path__ + "img/HPS012SH.ad9f55eb.png";